import { useContext } from 'react'

import { FormControlContext } from '../../components/FormControl'

export const useFormControlContext = () => useContext(FormControlContext)

export const useFormControl = props => {
  const context = useFormControlContext()
  if (!context) {
    return props
  }
  const keys = Object.keys(context)
  return keys.reduce((acc, prop) => {
    /** Giving precedence to `props` over `context` */
    acc[prop] = props[prop]

    if (context) {
      if (props[prop] == null) {
        acc[prop] = context[prop]
      }
    }

    return acc
  }, {})
}

export default useFormControl
